export default __webpack_public_path__ + "static/media/FinanceRealCase.21d0e76b.jpg";